import type { RefObject } from 'react';
import { IconeLoupe } from '../partage/icones';
import { CHERCHER, CHERCHER_DANS_LA_CARTE } from '../partage/vocabulaire';
import './TouchesDeLaCarte.css';

/**
 * La recherche de la carte (/, chantier modes-de-la-carte, modification 02 ; maquette
 * `quatre-themes.html`, `.cherche`) : une barre en haut de la carte ; ce qui est tapé pâlit les
 * bulles qu'elle ne trouve pas (`trouveeDans`). Échap dans le champ la ferme.
 */
export function ChercherDansLaCarte({
  valeur,
  champ,
  onChanger,
  onFermer,
  sousLaFrise,
}: {
  valeur: string;
  champ: RefObject<HTMLInputElement | null>;
  onChanger: (valeur: string) => void;
  onFermer: () => void;
  /** La frise ouverte (F) : la barre passe dessous. */
  sousLaFrise: boolean;
}) {
  return (
    <div className={`carte-cherche${sousLaFrise ? ' carte-cherche--sous-frise' : ''}`} role="search">
      <IconeLoupe className="carte-cherche-icone" />
      <input
        ref={champ}
        type="search"
        aria-label={CHERCHER}
        placeholder={`${CHERCHER_DANS_LA_CARTE}  ( / )`}
        autoComplete="off"
        value={valeur}
        onChange={(e) => onChanger(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== 'Escape') return;
          e.preventDefault();
          e.stopPropagation();
          e.currentTarget.blur();
          onFermer();
        }}
      />
    </div>
  );
}
